import styled from 'styled-components';

export const FilterButtonIconContainerMobileApp = styled.div`
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-sm);

  ion-icon {
    width: 20px !important;
    height: 20px !important;
  }
`;
